import { useState } from "react";
import { uploadRestaurantLogo } from "../services/restaurant";
import "../styles/style.css";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSaved: () => void;
  restaurantId: string;
  restaurantName: string;
}

function UploadRestaurantLogoModal({ isOpen, onClose, onSaved, restaurantId, restaurantName }: Props) {
  const [file, setFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0];
    if (!selected) return;
    setFile(selected);
    setPreview(URL.createObjectURL(selected));
    setError(null);
  };

  const handleUpload = async () => {
    if (!file) { setError("Lütfen bir dosya seçin."); return; }
    setUploading(true);
    setError(null);
    try {
      await uploadRestaurantLogo(restaurantId, file);
      onSaved();
      handleClose();
    } catch {
      setError("Yükleme sırasında hata oluştu.");
    } finally {
      setUploading(false);
    }
  };

  const handleClose = () => {
    setFile(null);
    setPreview(null);
    setError(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="url-backdrop">
      <div className="url-modal">
        <div className="url-modal-header">
          <h5 className="url-modal-title">
            <i className="bi bi-image"></i>Logo Güncelle
          </h5>
          <button className="url-close-btn" onClick={handleClose}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <p className="url-modal-desc">
          <strong style={{ color: '#111827' }}>{restaurantName}</strong> için yeni logo seçin.
        </p>

        {preview && (
          <div className="url-preview-wrap">
            <img src={preview} alt="önizleme" className="url-preview-img" />
          </div>
        )}

        <div className="mb-3">
          <label className="url-field-label">Dosya Seç (PNG veya JPEG)</label>
          <input
            className="form-control"
            type="file"
            accept="image/png,image/jpeg"
            onChange={handleFileChange}
          />
        </div>

        {error && (
          <div className="url-error">
            <i className="bi bi-exclamation-circle me-1"></i>{error}
          </div>
        )}

        <div className="url-actions">
          <button className="url-btn url-btn--cancel" onClick={handleClose} disabled={uploading}>
            İptal
          </button>
          <button className="url-btn url-btn--upload" onClick={handleUpload} disabled={uploading || !file}>
            {uploading
              ? <span className="spinner-border spinner-border-sm"></span>
              : <i className="bi bi-cloud-upload"></i>
            }
            Yükle
          </button>
        </div>
      </div>
    </div>
  );
}

export default UploadRestaurantLogoModal;
